"use client"

import React, { createContext, useContext } from "react";

const TranslationContext = createContext<Record<string, string>>({});

export const TranslationProvider = ({
                                        translations,
                                        children,
                                    }: {
    translations: Record<string, any>;
    children: React.ReactNode;
}) => {
    return (
        <TranslationContext.Provider value={translations}>
            {children}
        </TranslationContext.Provider>
    );
};

export const useTranslations = () => {
    const context = useContext(TranslationContext);
    if (!context) {
        throw new Error("useTranslations must be used within a TranslationProvider");
    }
    return context;
};